import React, { useState, lazy } from 'react';
import styles from '../styles/kidsTracking.module.css';
import useMediaQuery from '../../../hooks/useMediaQuery';

const PhoneVerificationComponent = lazy(() => import('../../../components/sharedComponents/PhoneVerification'));


const KidsTrackingHero = () => {

    const isAboveMediumScreens = useMediaQuery("(min-width: 500px)");

    const [toggleSearchInput, setToggleSearchInput] = useState(true);

    const togglePhoneVerificationPopup = (e) => {
        e.preventDefault();
        setToggleSearchInput(!toggleSearchInput);
    }

    const mediaUrl = process.env.REACT_APP_PUBLIC_CDN_URL;
    const backGroundImage = mediaUrl + '/images/kidsTrackingBig.webp';

    return (
        <section>
            <div className={styles.heroBgImage} style={{ backgroundImage: `url(${backGroundImage})` }}>
                <div className={styles.homeHeroInnerContainer}>
                    <div className='maxScreen'>
                        {!isAboveMediumScreens && <div className={styles.emptyContainer}></div>}
                        <div className={styles.heroContainer}>
                            <h1 className={styles.heading}><span className="hightLightText">Keep Them Safe</span>
                                <br></br>With The World’s  #1<br></br>Tracking
                                App For Kids </h1>
                            <p className={styles.paragraph}>
                                As your children start exploring the world on their own, it’s natural to worry. Device Tracker Plus keeps you in the loop without overstepping boundaries so that they can enjoy their independence and you can relax. </p>
                            <br />
                            <br />
                            <div className='inputContainer'>
                                {toggleSearchInput && <PhoneVerificationComponent showPopUp={togglePhoneVerificationPopup} />}
                            </div>

                        </div>
                        <div className={styles.emptyContainer}></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default KidsTrackingHero;